module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1504-c83bc2947a3980ebecbb1c7cc59102e5.png";